import {
  IPageResultsResponse,
  IReport,
  IWorkflowItemStep,
  PagedResultsRequest,
} from "../../../../common/sharedTypes";

export class SearchCheckersQueuePagedRequest extends PagedResultsRequest {
  public assignedOnly: boolean;
  public unassignedOnly: boolean;
  public userOnly: boolean;
  public startDate?: string;
  public endDate?: string;
  public workflowStatus?: number;
  public workflowItemStepId?: number;
}

export class CheckersQueueItem {
  id?: number;
  createdDate?: Date;
  dateOfCrash?: string | Date;
  reportId?: number;
  crashReportId?: number;
  documentId?: string;
  assignedToUserName?: string;
  assignedToUserId?: number;
  agencyName?: string;
  countyName?: string;
  workflowStatus?: string;
  priorityName?: string;
  priorityNumber?: number;
  originalCrashKey?: string;
  reportStatusId?: number;
  reportsMergedToThis?: IReport[];
  supplementedReports?: IReport[];
  completedDate?: Date;
  hasMergedDriverReport?: boolean;

  constructor(workflowItem: IWorkflowItemStep) {
    this.id = workflowItem.id;
    this.createdDate = workflowItem?.workflowItem?.report?.createdDate;
    this.documentId = workflowItem?.workflowItem?.report?.documentId;
    this.assignedToUserName = workflowItem?.user?.userName;
    this.agencyName = workflowItem?.workflowItem?.report?.keywords?.agency?.name;
    this.workflowStatus = workflowItem?.workflowStepStatus?.name;
    this.priorityName = workflowItem?.workflowItem?.report?.keywords?.priorityName;
    this.priorityNumber = workflowItem?.workflowItem?.report?.keywords?.priorityNumber;
    this.originalCrashKey = workflowItem.workflowItem?.report?.keywords?.originalCrashKey;
    this.countyName = workflowItem?.workflowItem?.report?.keywords?.county?.description;
    this.reportStatusId = workflowItem?.workflowItem?.report?.reportStatusId;
    this.dateOfCrash = workflowItem?.workflowItem?.report?.keywords?.dateOfCrash;
    this.reportId = workflowItem?.workflowItem?.reportId;
    this.crashReportId = workflowItem?.workflowItem?.report?.crashReportId;
    this.reportsMergedToThis = workflowItem?.workflowItem?.report?.reportsMergedToThis;
    this.supplementedReports = workflowItem?.workflowItem?.report?.supplementedReports;
    this.completedDate = workflowItem?.workflowItem?.report?.completedDate;
    this.hasMergedDriverReport = workflowItem?.workflowItem?.report?.hasMergedDriverReport;
  }
}

export interface ISearchCheckersQueuePagedResponse extends IPageResultsResponse {
  queueItems?: CheckersQueueItem[];
}
